import { useParams } from "react-router";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { useHtzSummaryShowQuery } from "@/services/backend/htz/summary/api/summary-api";
import { SummaryAddressesAndContacts } from "@/services/backend/htz/summary/components/summary-addresses-and-contacts";
import { CardSkeleton } from "@/shared/components/card-skeleton";

export function AddressesAndContactsRoute() {
  const { summaryId } = useParams();
  const { data } = useHtzSummaryShowQuery({ id: summaryId! });

  if (!data) return <CardSkeleton />;

  return (
    <SummaryAddressesAndContacts id={data.id} disabled={isImmutable(data)} />
  );
}
